(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbg-squeeze-funnel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-sbg-funnel]');
  if (!root) return;
  const floating = root.querySelector('[data-sbg-floating]');
  const stickyTrigger = root.querySelector('[data-sbg-sticky-trigger]');
  const finalSection = root.querySelector('[data-sbg-final]');
  const gallery = root.querySelector('[data-sbg-gallery]');
  if (gallery) {
    const stage = gallery.querySelector('[data-sbg-gallery-stage]');
    const thumbs = [...gallery.querySelectorAll('[data-kind]')];
    const activate = (button) => {
      if (!stage || !button) return;
      thumbs.forEach((item) => item.classList.toggle('is-active', item === button));
      const kind = button.dataset.kind;
      const src = button.dataset.src;
      const alt = button.dataset.alt || '';
      if (kind === 'video') {
        const video = document.createElement('video');
        video.autoplay = true;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('muted','');
        video.setAttribute('playsinline','');
        video.setAttribute('webkit-playsinline','');
        video.setAttribute('aria-label', alt);
        if (button.dataset.poster) video.poster = button.dataset.poster;
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        video.appendChild(source);
        stage.replaceChildren(video);
        const play = video.play();
        if (play && typeof play.catch === 'function') play.catch(() => {});
      } else {
        const image = document.createElement('img');
        image.src = src;
        image.alt = alt;
        image.loading = 'eager';
        stage.replaceChildren(image);
      }
    };
    thumbs.forEach((button) => button.addEventListener('click', () => activate(button)));
  }
  const founderVideo = root.querySelector('[data-sbg-founder-video]');
  if (founderVideo) {
    const startFounder = () => {
      founderVideo.muted = true;
      founderVideo.defaultMuted = true;
      founderVideo.playsInline = true;
      founderVideo.setAttribute('muted', '');
      founderVideo.setAttribute('playsinline', '');
      founderVideo.setAttribute('webkit-playsinline', '');
      if (founderVideo.readyState === 0) founderVideo.load();
      const play = founderVideo.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const founderObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          startFounder();
        }
      }, { rootMargin: '500px 0px', threshold: 0.01 });
      founderObserver.observe(founderVideo);
    } else {
      startFounder();
    }
    founderVideo.addEventListener('loadeddata', startFounder, { once: true });
    founderVideo.addEventListener('canplay', startFounder, { once: true });
    window.addEventListener('pageshow', startFounder);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) startFounder();
    });
  }

  const thumbPrev = root.querySelector('[data-sbg-thumb-prev]');
  const thumbNext = root.querySelector('[data-sbg-thumb-next]');
  const thumbRail = root.querySelector('.sbgf-gallery__thumbs');
  const slideThumbs = (direction) => {
    if (!thumbRail) return;
    const firstThumb = thumbRail.querySelector('[data-kind]');
    const step = firstThumb ? firstThumb.getBoundingClientRect().width + 8 : thumbRail.clientWidth * 0.7;
    thumbRail.scrollBy({ left: step * direction * 3, behavior: 'smooth' });
  };
  if (thumbPrev) thumbPrev.addEventListener('click', () => slideThumbs(-1));
  if (thumbNext) thumbNext.addEventListener('click', () => slideThumbs(1));
  const links = root.querySelectorAll('a[href^="#"]');
  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('href');
      if (!id || id === '#') return;
      const target = root.querySelector(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });
  const updateFloating = () => {
    let show = false;
    if (stickyTrigger) {
      const triggerRect = stickyTrigger.getBoundingClientRect();
      show = triggerRect.top <= window.innerHeight;
    }
    if (finalSection) {
      const rect = finalSection.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.72 && rect.bottom > 0) show = false;
    }
    floating.classList.toggle('is-active', show);
    floating.setAttribute('aria-hidden', show ? 'false' : 'true');
  };
  updateFloating();
  window.addEventListener('scroll', updateFloating, { passive: true });
  window.addEventListener('resize', updateFloating);
})();

  } catch(e) { console.error(e); }
})();
})();
